export default {
  path: '/contract_types',
  name: 'contract_types',
  component: () => import('../components/contracttype/Layout'),
  redirect: { name: 'ContracttypeList' },
  meta: {
    breadcrumb: 'contract.contracttypes',
  },
  children: [
    {
      name: 'ContracttypeList',
      path: '',
      component: () => import('../views/contracttype/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ContracttypeCreate',
      path: 'new',
      component: () => import('../views/contracttype/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ContracttypeUpdate',
      path: ':id/edit',
      component: () => import('../views/contracttype/Update'),
      meta: {
        breadcrumb: 'contract.contracttype',
      },
    },
    {
      name: 'ContracttypeShow',
      path: ':id',
      component: () => import('../views/contracttype/Show'),
      meta: {
        breadcrumb: 'contract.contracttype',
      },
    }
  ]
};
